import { axiosClient } from 'www/utils'
import type { ApiScheduleDoctorsParamsPost, ApiScheduleDoctorsResponsePost } from 'www/api/apiScheduleDoctors.types'

export default {
  post(params: ApiScheduleDoctorsParamsPost) {
    return axiosClient.post<ApiScheduleDoctorsResponsePost>('/ajax/schedule/slots_bulk/', params)
  },
}
